import mutationTypes from './mutationTypes'
import { Opportunity } from '@/types'
import getterTypes from './getterTypes'

interface TrackerState {
  opportunities: Opportunity[]
  error: Error | null
}

const rootState: TrackerState = {
  opportunities: [],
  error: null,
}

const mutations = {
  [mutationTypes.SET_OPPORTUNITIES.VALUE]: (
    state: TrackerState,
    opportunities: Opportunity[]
  ) => {
    state.opportunities = opportunities
  },
  [mutationTypes.SET_ERROR.VALUE]: (
    state: TrackerState,
    error: Error | null
  ) => {
    state.error = error
  },
}

const getters = {
  [getterTypes.OPPORTUNITIES.VALUE]: (state: TrackerState) => {
    return state.opportunities
  },
  [getterTypes.ERROR.VALUE]: (state: TrackerState) => {
    return state.error
  },
}

export default {
  namespaced: true,
  state: rootState,
  mutations,
  getters,
}
